import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal , ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';
import { environment} from '../../../environments/environment';

@Component({
  selector: 'app-super-admin',
  templateUrl: './super-admin.component.html',
  styleUrls: ['./super-admin.component.scss']
})
export class SuperAdminComponent implements OnInit {
  submitted = false;userId:any='';type:any='';
  searchText = ""; user_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  data = {}; userData: any; capsule_name: any; media_type = ''; adminData: any; filter_by: any = "";
  tabName: any = ''; user_id: any = '';
  user_type:number=2

  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) { 
      if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
        this.router.navigateByUrl('/admin-login');
      }
    }

  open(content: any, user_id: any, tab_name: any) {
    this.tabName = tab_name;
    this.user_id = user_id;
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  ngOnInit(): void {
    this.spinner.show();
    this.is_active = '1';
    this.user_status = '2';
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type); //draft
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.userId = queryParams['id'];
      this.type = queryParams['type'];
    });
    if (this.userId != '' && this.userId != null) {
     // this.getUserDetails(this.userId);
    }
  }

  /*******get active and deactive data of users */
  onSelectChange(event: any) {
    if (event.index == 1) { //deactive
      this.is_active = '0';
    } else {
      this.is_active = '1'; //active
    }
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by,this.user_type);
  }
  /*get user lidting data********/
  getUserList(searchText: any, is_active: any, order_by: any, order: any, filter_by: any,user_type:number) {
    this.spinner.show();
    this.contentAuthoringApi.getUserList(searchText, is_active, order_by, order, filter_by,user_type).subscribe(
      (data) => {
        console.log(data);
        if (data.success) {
          this.spinner.hide();
          this.userData = data.userList;
          // console.log(this.userData);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  /*****get data by searching by name */
  search(event: any) {
    this.searchText = event.target.value;
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }
  /*****get data by asc or desc order by shorting click ******/
  // sorting(event: any) {
  //   this.searchText = event.target.value;
  //   this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by);
  // }
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    // this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
    this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by, this.user_type);
  }
  /*****click on logout button function ******/
  logout() {
   // localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(user_id: any, is_actives: any) {
    this.changeIsActiveVal(user_id, is_actives);
  }
  changeIsActiveVal(user_id: any, is_active: any) {
    this.contentAuthoringApi.changeAdminUserIsActiveVal(user_id, is_active).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.getUserList(this.searchText, this.is_active, this.order_by, this.order, this.filter_by,this.user_type);
         // this.router.navigate(['/courses']);
        } else {
           this.errorInfo.isError = true;
           this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.errorInfo.errorMsg = error;
      },
    );
   }
}
